import type { FC } from 'react';
import { useEffect } from 'react';

import { Typography } from '@capsule/consumer-design-system';

import { css } from 'styled-components';

import { MedicationList } from 'src/app/components/PageSections/DoctorTransferForm/MedicationsFieldArray/MedicationList';
import {
  GrayBox,
  MedicationListContainer,
} from 'src/app/components/PageSections/DoctorTransferForm/MedicationsFieldArray/styles';
import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import type { Medication } from 'src/app/types';

export const DoctorRequiredMedications: FC<{ medications: Medication[] | string[] }> = ({ medications }) => {
  const medication_names = medications.map(med => (typeof med === 'string' ? med : med.name));

  const trackViewAskYourDoctorBox = useSegmentEvent('viewAskYourDoctorBox', {
    shouldTrackOnMount: false,
  });

  const trackViewEvent = () => trackViewAskYourDoctorBox({ medication_names });

  useEffect(() => {
    trackViewEvent();
    window.addEventListener('beforeunload', trackViewEvent); // if tab closes

    return () => {
      trackViewEvent();
      window.removeEventListener('beforeunload', trackViewEvent);
    };
  }, []);

  return (
    <GrayBox>
      <div>
        <Typography
          variant="heading4"
          css={css`
            margin-bottom: ${({ theme }) => theme.space.s1};
          `}
        >
          Ask your doctor to send the following prescriptions to Capsule
        </Typography>

        <Typography>Your doctor needs to directly send us prescriptions for controlled substances</Typography>
      </div>

      <MedicationListContainer bold>
        <MedicationList medications={medications} hideMedicationHeader />
      </MedicationListContainer>
    </GrayBox>
  );
};
